import type { RouteRecordRaw } from 'vue-router';
import RegisterSignInPage from './pages/RegisterSignInPage/RegisterSignInPage.vue';
import PresentationPage from './pages/PresentationPage/PresentationPage.vue';
import ChildUserLoginPage from './pages/ChildUserLoginPage/ChildUserLoginPage.vue';
import ResetPasswordPage from './pages/ResetPasswordPage/ResetPasswordPage.vue';
import ForgotPasswordPage from './pages/ForgotPasswordPage/ForgotPasswordPage.vue';

export const main: RouteRecordRaw[] = [];

export const base: RouteRecordRaw[] = [
  {
    name: 'users.signin',
    path: 'users/signin',
    component: RegisterSignInPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    name: 'users.register',
    path: 'users/signin',
    component: RegisterSignInPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    name: 'users.presentation',
    path: 'users/presentation',
    component: PresentationPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    name: 'users.connect',
    path: 'users/connect/:provider/redirect',
    component: RegisterSignInPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    name: 'users.child.login',
    path: 'users/child/login',
    component: ChildUserLoginPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    name: 'users.password.reset',
    path: 'users/password/reset',
    component: ResetPasswordPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    name: 'users.password.forgot',
    path: 'users/password/forgot',
    component: ForgotPasswordPage,
    meta: {
      requiresAuth: false,
    },
  },
];
